'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
function getDevice() {
  var desktopBreakpoint = 992;
  if (window.innerWidth >= desktopBreakpoint) {
    return 'desktop';
  }
  return 'mobile';
}

exports.default = getDevice;